import { useQuery } from '@tanstack/react-query';
import { getGalleryFilterTags } from '@/services/cloudinary';

interface UseGetGalleryFilterTagsOptions {
  baseTag?: string;
}

export default function useGetGalleryFilterTags({
  baseTag = 'gallery_main',
}: UseGetGalleryFilterTagsOptions = {}) {
  return useQuery({
    queryKey: ['gallery_filter_tags', baseTag],
    queryFn: () => getGalleryFilterTags(baseTag),
    staleTime: 5 * 60 * 1000, // 5 minutes — filter tags change rarely
  });
}
